import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { CurrentService } from "app/services/current.service";
import { Router } from "@angular/router";

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  constructor(private currentService: CurrentService, private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentTenant = this.currentService.currentTenant.getValue();

    if (currentTenant?.id) {
      request = request.clone({
        setHeaders: {
          "X-Tenant-ID": currentTenant?.id,
        },
      });
    }

    return next.handle(request);
  }
}
